import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!mounted) {
        return null;
    }

    const portalRoot = document.getElementById('portal-root');
    if (!portalRoot) {
        // Isso não deve acontecer se o index.html estiver configurado corretamente.
        console.error("O elemento com id 'portal-root' não foi encontrado no DOM.");
        return null;
    }

    return createPortal(children, portalRoot);
};

export default Portal;